export const UNIT_SELECTOR = {
  HEADER_TEXT: "Select a Size",
  SMALLER_TEXT: "Go Smaller",
  BIGGER_TEXT: "Go Larger",
  BUTTON_TEXT: "Get a Price Now",
};

export const CONTACT_FORM = {
  HEADER_TEXT: "We just need a few details",
  BUTTON_TEXT: "Get Price",
};

export const QUOTE_PAGE = {
  HEADER_TEXT: "Thanks {{name}}. Here is your storage quote",
  BUTTON_TEXT: "Book Now",
};

export const BOOKING_FORM = {
  HEADER_TEXT: "Let's book you in",
  BUTTON_TEXT: "Complete order",
  BUTTON_TEXT_SUBMITTING: "Completing your order...",
  INSURANCE_SUBTEXT:
    "{name} provides goods protection at exceptional value, through StoreProtect. This protection is not included in our rent charges. It is required that all items in storage are protected for their full and true replacement value.",
  SELF_INSURANCE_SUBTEXT:
    "Select this option if you would like to provide your own insurance.",
  STUDENT_INSURANCE: "I am a Student and will provide a valid Student ID",
  STUDENT_INSURANCE_SUBTEXT:
    "Select this option if you qualify for the Student Deal with the inclusive Student Cover.",
  DECLARED_GOODS_TC:
    "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
  SECURITY_DEPOSIT: "Security deposit refunded in full upon vacating your space",
  PAYMENT_PROMPT:
    "*Selecting this option may prompt a further £0 value transaction in your banking app.",
  TERMS_AND_CONDITIONS_WAIVER:
    "I have read the Privacy Policy and agree to the Terms and Conditions above.",
  ALLOW_MARKETING: "Allow marketing",
  DUE: "Due today",
  SECTION_HEADERS: {
    MOVE_IN: "Move in date",
    CONTACT_DETAILS: "Contact details",
    INSURANCE_COVERAGE: "StoreProtect",
    DECLARED_VALUE: "Declared Value of Goods Stored",
    PACKAGING_BUNDLE: "Packaging Bundle Offer - Click and Collect",
    EXTRAS: "Extras & Add ons",
    SUMMARY: "Your Booking Summary",
    PAYMENT_DETAILS: "Payment Details",
  },
};

export const BOOK_CONFIRMED = {
  STEP_0: "Contact our team to confirm your booking",
  STEP_1: "Check your email for your booking confirmation",
  STEP_2: "Download our app",
  STEP_3: "Verify your identity",
  STEP_4: "Set Up Secure Auto Pay",
  STEP_5: "Access your unit",
};

export const PADLOCK_TYPES = [
  {
    name: "Padlock",
    key: "padlock_required",
    description: "(Available as Key or Combination, Insurer-approved)",
    total: 10.0,
    type: "extra",
    active: true,
    category: "packaging-+-extras" as const,
  },
  {
    name: "Padlock not required",
    key: "padlock_required",
    description: "(Secure, bullet-lock system - No Padlock required!)",
    total: 0,
    type: "extra",
    active: true,
    category: "packaging-+-extras" as const,
  },
  {
    name: "Padlock not required",
    key: "padlock_required",
    description: "(State of the art keyless lock on every door)",
    total: 0,
    type: "extra",
    active: true,
    category: "packaging-+-extras" as const,
  },
];

// All SureStore has bullet padlocks (except Stafford and York)
export const BULLET_PADLOCK_LOCATIONS = [
  "ASH",
  "BOLT",
  "BURT",
  "BURY",
  "CAN",
  "LICH",
  "NOR",
  "OLDT",
  "WIG",
  "WOK",
];
// All TSSC and Stafford
export const PADLOCK_LOCATIONS = ["STAF", "APEX", "HEM", "WAL", "WEL", "MOL", "LTRAIN"];

export const CHARGES = [
  {
    name: "Extended hours access",
    desc: "Extended hours Service",
    line_item_name: "First 4 weeks extended access",
    key: "extended_access",
    type: "extra",
    description: "(6am - 10pm, 7 days a week)",
  },
];

export const BUNDLE_PRODUCTS = [
  "1 - MINI Bundle",
  "2 - STANDARD Bundle",
  "3 - PREMIUM Bundle",
  "4 - PLATINUM Bundle",
  // "Test Box",
];

export const BUNDLES = [
  {
    _id: "",
    name: "Mini",
    line_item_name: "Mini box & packaging bundle",
    key: "mini",
    type: "Boxes",
    total: 38.0,
    active: false,
    discounted: true,
    discountedRate: 25.0,
    contents: ["5 medium boxes", "1 tape", "1 50cm x 10m bubble wrap"],
  },
  {
    _id: "",
    name: "Standard",
    line_item_name: "Standard box & packaging bundle",
    key: "standard",
    type: "Boxes",
    total: 62,
    active: false,
    discounted: true,
    discountedRate: 45.0,
    contents: ["5 small boxes", "5 medium boxes", "5 large boxes", "1 tape"],
  },
  {
    _id: "",
    name: "Premium",
    line_item_name: "Premium box & packaging bundle",
    key: "premium",
    type: "Boxes",
    total: 109,
    active: false,
    discounted: true,
    discountedRate: 70.0,
    contents: ["5 small boxes", "10 medium boxes", "10 large boxes", "2 tapes"],
  },
  {
    _id: "",
    name: "Platinum",
    line_item_name: "Platinum box & packaging bundle",
    key: "platinum",
    type: "Boxes",
    total: 169,
    active: false,
    discounted: true,
    discountedRate: 95.0,
    contents: ["10 small boxes", "15 medium boxes", "15 large boxes", "2 tapes"],
  },
  {
    _id: "",
    name: "No Bundle",
    line_item_name: "No Bundle",
    key: "no_bundle",
    type: "Boxes",
    total: 100,
    active: false,
    discounted: true,
    discountedRate: 1.32,
    contents: ["BEES", "OVER"],
  },
];

export const CARD_TYPES = [
  {
    type: "5",
    name: "Mastercard",
  },
  {
    type: "6",
    name: "Visa",
  },
  // {
  //   type: "7",
  //   name: "AMEX",
  // },
];
